// use this when extending 3rd party components, for example
/*
    export const StyledIcon = styled(FontAwesomeIcon, {
        shouldForwardProp,
    })<IconProps>`...`
*/
export const shouldForwardProp = (prop: any) => !prop.startsWith("$");
